(() => {
  const sectionSelector = '[data-vena-results-section]';
  const batchSizeDefault = 8;
  const maxRenderedCards = 48;

  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };

  const reviewCard = (review) => {
    const card = element('article', 'vena-demo-review');
    const person = element('div', 'vena-demo-review__person');
    const avatar = element('span', 'vena-demo-review__avatar', review.initials);
    const identity = element('div');
    const name = element('p', 'vena-demo-review__name', `${review.name} · ${review.location}`);
    const meta = element('p', 'vena-demo-review__meta', review.detail);
    const rating = element('div', 'vena-demo-review__rating');
    const product = element('span', 'vena-demo-review__product', review.product);
    const stars = element('span', 'vena-demo-review__stars', review.rating === 4.5 ? '★★★★½' : '★★★★★');
    stars.setAttribute('aria-label', `${review.rating} out of 5 stars`);
    const ratingValue = element('strong', 'vena-demo-review__rating-value', review.rating.toFixed(1));
    const body = element('p', 'vena-demo-review__text', `“${review.body}”`);
    identity.append(name, meta);
    person.append(avatar, identity);
    rating.append(stars, ratingValue, product);
    card.append(person, rating, body);
    return card;
  };

  const initialise = (section) => {
    if (section.dataset.venaReviewsReady === 'true') return;
    const open = section.querySelector('[data-vena-reviews-open]');
    const modal = section.querySelector('[data-vena-reviews-modal]');
    const close = modal?.querySelector('[data-vena-reviews-close]');
    const scroll = modal?.querySelector('[data-vena-reviews-scroll]');
    const list = modal?.querySelector('[data-vena-reviews-list]');
    const sentinel = modal?.querySelector('[data-vena-reviews-sentinel]');
    if (!open || !modal || !close || !scroll || !list || !sentinel) return;
    section.dataset.venaReviewsReady = 'true';

    const batchSize = Number(section.dataset.reviewBatchSize) || batchSizeDefault;
    const productName = section.dataset.reviewProduct || 'Vena Pure Magic Body Oil';
    let offset = 0;
    let observer;
    let lastFocused;
    let loading = false;

    const getProvider = () => window.VenaDemoReviewData?.get;

    const renderBatch = () => {
      if (loading) return;
      const provider = getProvider();
      if (typeof provider !== 'function') {
        sentinel.textContent = 'Review demo data is unavailable.';
        return;
      }
      loading = true;
      sentinel.textContent = 'Loading more demo review cards…';
      window.requestAnimationFrame(() => {
        const reviews = provider(offset, batchSize, productName);
        const fragment = document.createDocumentFragment();
        reviews.forEach((review) => fragment.append(reviewCard(review)));
        list.append(fragment);
        offset += reviews.length;

        if (list.children.length > maxRenderedCards) {
          let removedHeight = 0;
          while (list.children.length > maxRenderedCards - batchSize) {
            const first = list.firstElementChild;
            removedHeight += first.offsetHeight + 20;
            first.remove();
          }
          scroll.scrollTop = Math.max(0, scroll.scrollTop - removedHeight);
        }
        loading = false;
        sentinel.textContent = 'Scroll for more demo review cards';
      });
    };

    const openModal = () => {
      lastFocused = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.dataset.venaOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      list.innerHTML = '';
      offset = 0;
      scroll.scrollTop = 0;
      renderBatch();
      if (observer) observer.disconnect();
      observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) renderBatch();
      }, { root: scroll, rootMargin: '220px 0px' });
      observer.observe(sentinel);
      close.focus();
    };

    const closeModal = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      if (observer) observer.disconnect();
      document.body.style.overflow = document.body.dataset.venaOverflow || '';
      delete document.body.dataset.venaOverflow;
      lastFocused?.focus?.();
    };

    open.addEventListener('click', openModal);
    close.addEventListener('click', closeModal);
    modal.addEventListener('click', (event) => { if (event.target === modal) closeModal(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal(); });
  };

  const initialiseAll = (scope = document) => {
    const sections = scope.matches?.(sectionSelector) ? [scope] : scope.querySelectorAll(sectionSelector);
    sections.forEach(initialise);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialiseAll());
  else initialiseAll();
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();